module.exports = __webpack_public_path__ + "media/workplace/rating-unsure-fill-a388f7e7.svg";